import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from './locales/ar.json';
import en from './locales/en.json';

export const LANG_KEY = 'omaraty.lang';

export type Language = 'ar' | 'en';

function initialLanguage(): Language {
  const stored = localStorage.getItem(LANG_KEY);
  return stored === 'en' ? 'en' : 'ar';
}

void i18n.use(initReactI18next).init({
  resources: {
    ar: { translation: ar },
    en: { translation: en },
  },
  lng: initialLanguage(),
  fallbackLng: 'ar',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function directionOf(language: string): 'rtl' | 'ltr' {
  return language === 'ar' ? 'rtl' : 'ltr';
}

export default i18n;
